module.exports = __webpack_public_path__ + "img/link_f_img05.6aa6cddc.gif";